var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.getClassObject,attrs:{"tab-index":_vm.tabIndex}},[_c('router-link',{attrs:{"to":{ name: _vm.routeName}}},[_vm._v(_vm._s(_vm.routeLabel))]),_vm._v(" "),_vm._l((_vm.children),function(child){return _c('navigation-item',{key:child.routeName,attrs:{"route-name":child.routeName,"route-label":child.routeLabel}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d18e070e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationItem.vue
// module id = 1r/y
// module chunks = 1